export default{
    methods: {
        globalDateFormat(date){
            const currentDate = date ? this.$moment(new Date(date)).format('DD/MM/YYYY') : ""
            return currentDate
        },
    },
}